import React, { useEffect } from 'react';

// const useOutsideClick = (
//   ref: React.MutableRefObject<any>,
//   fn: (e: Event) => void,
//   outSideOnly = true,
// ): void => {
//   // REFERENCE: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component

//   useEffect(() => {
//     function handleClickOutside(event: Event) {
//       if (
//         !outSideOnly ||
//         (ref.current && !ref.current.contains(event.target))
//       ) {
//         fn(event);
//       }
//     }
//     // Bind the event listener
//     document.addEventListener('click', handleClickOutside, false);
//     return () => {
//       // Unbind the event listener on clean up
//       document.removeEventListener('click', handleClickOutside, false);
//     };
//   }, [ref, fn, outSideOnly]);
// };
function useOutsideClick(ref: any, handler: any) {
  useEffect(
    () => {
      const listener = (event: { target: any; }) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}
export default useOutsideClick;
